{
  "nav": {
    "home": "Home",
    "services": "Leistungen",
    "prices": "Preise",
    "projects": "Projekte",
    "about": "Über Khromatik",
    "contact": "Kontakt",
    "email": "E-Mail",
    "linkedin": "LinkedIn"
  },
  "backToProjects": "Zurück zu den Projekten",
  "projectOverview": "Projektübersicht",
  "overview": "Übersicht",
  "challenge": "Die Herausforderung",
  "businessNeed": "Der Geschäftsbedarf",
  "philosophy": "Die Philosophie",
  "goal": "Das Ziel",
  "solution": "Die Lösung",
  "polestarLandingPage": "Polestar-Live-Landingpage",
  "footer": {
    "legal": "Impressum"
  },
  "whatsapp": {
    "label": "Kontakt per WhatsApp",
    "prefill": "Guten Tag. Interesse an einem Gespräch über ein Video- oder Branding-Projekt."
  },
  "cookies": {
    "title": "Cookies und Datenschutz",
    "body": "Die Website setzt optionale Analyse-Tools (Google Analytics und Microsoft Clarity) ein, um die Nutzung zu verstehen. Nicht notwendige Cookies können abgelehnt oder akzeptiert werden. Die notwendige Speicherung betrifft Sprache und diese Auswahl.",
    "learnMore": "Weitere Informationen",
    "accept": "Alle akzeptieren",
    "reject": "Nicht notwendige ablehnen",
    "settings": "Cookie-Einstellungen"
  }
}
